<template>
  <div class="orderPage">
    <div class="tit flex-rowl">
      <p>{{ dataInfo.datestr }}</p>
      <p>{{ dataInfo.shop_name }}</p>
    </div>
    <div class="loudong_wrap">
      <div class="head flex-between">
        <p class="txt1">送餐楼栋</p>
        <p class="txt2">取餐状态</p>
      </div>
      <div class="body flex-between">
        <p class="txt1">{{ dataInfo.parametername }}-{{ dataInfo.buildingname }}</p>
        <p class="txt2">
          <span>{{ dataInfo.getnum }}</span
          >/<span>{{ dataInfo.totalnum }}</span>
        </p>
      </div>
    </div>

    <div class="order_wrap">
      <div class="head flex-between">
        <p class="txt1">订单号</p>
        <p class="txt2">取餐状态&取餐人明细</p>
      </div>
      <div class="body">
        <div
          class="item"
          v-for="(item, index) in detailList"
          :key="index"
        >
          <div class="item_main flex-between">
            <p class="txt1">{{ item.order_id }}</p>
            <p class="txt2">{{ item.stateview }}</p>
          </div>
          <div class="item_wrap01 flex-rowl">
            <p>{{ item.truename }}</p>
            <p>{{ item.customer_phone }}</p>
          </div>
          <div class="item_wrap02">
            <p>{{ item.order_content }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="custom_btn fixd" @click="handleReturn">返回</div>
  </div>
</template>
  
  <script>
import { getToken, encryptstringview, getShopLouDetail } from "../../api/api";
export default {
  name: "orderDataDetail",
  data() {
    return {
      userInfo: "",

      dataInfo: "",
      detail: "",

      token: "",
      detailList: [],
    };
  },
  created() {
    let userInfo = this.$store.state.USERINFO;
    this.userInfo = userInfo;
    console.log(this.$route.params.id);

    if (this.$route.params.id) {
      this.encryptstringview(this.$route.params.id, userInfo.openid);
    }
    // this.getToken();
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { data } = JSON.parse(res.jsondata);
        this.dataInfo = data;
        this.getShopLouDetail();
      } else {
        this.$router.back();
      }
    },

    // 获取token
    getToken() {
      getToken().then((res) => {
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);
          this.token = res.data.token;
          this.getShopLouDetail();
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    // 获取楼栋详情
    getShopLouDetail() {
      let toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      let { token, dataInfo } = this;
      let params = {
        token,
        datestr: dataInfo.datestr,
        shopname: dataInfo.shop_name,
        address_detail: dataInfo.address_detail,
        parameterid: dataInfo.parameterid,
        buildingid: dataInfo.buildingid,
      };
      getShopLouDetail(params).then((res) => {
        if (res.result) {
          this.detailList = res.list;
          toast.clear();
        } else {
          // token过期
          if (res.error_code == 1) {
            this.getToken();
          } else {
            this.$toast.fail(res.message);
          }
        }
      });
    },
    // 返回上一页
    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
  <style lang='less' scoped>
.orderPage {
  padding: 50px 0 320px;
  box-sizing: border-box;
  .tit {
    width: 710px;
    margin: auto;
    font-size: 36px;
    font-weight: bold;
    p {
      margin-right: 30px;
    }
  }
  .loudong_wrap {
    width: 710px;
    margin: 60px auto 90px;
    font-size: 32px;
    .head {
      font-weight: bold;
      margin-bottom: 20px;
    }
    p {
      flex-shrink: 0;
    }
    .txt1 {
      width: 460px;
    }
    .txt2 {
      width: 200px;
    }
  }
  .order_wrap {
    font-size: 30px;
    .head {
      font-weight: bold;
      margin-bottom: 30px;
      padding: 0 20px;
      box-sizing: border-box;
    }
    .body {
      .item {
        font-size: 26px;
        padding: 35px 20px;
        box-sizing: border-box;
        &:nth-child(2n-1) {
          background: #eeeeee;
        }
        .item_main {
          font-size: 28px;
        }
        .item_wrap01 {
          margin: 20px 0;
          p {
            &:last-child {
              margin-left: 40px;
            }
          }
        }
      }
    }
    p {
      flex-shrink: 0;
    }
    .txt1 {
      width: 390px;
    }
    .txt2 {
      width: 300px;
      text-align: center;
    }
  }
  .custom_btn {
    &.fixd {
      position: fixed;
      left: 50%;
      transform: translateX(-50%);
      bottom: 220px;
    }
  }
}
</style>